module.exports = __webpack_public_path__ + "static/media/4.d5f6a3d6.jpeg";